import { render, staticRenderFns } from "./PopupBrowserSupport.vue?vue&type=template&id=587c0aba"
import script from "./PopupBrowserSupport.vue?vue&type=script&lang=js"
export * from "./PopupBrowserSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports